const MAIN = "/narzedzia/regagri-explorer";
const CULTIVATION_DETAILS = "/regagri-explorer";

export default {
  MAIN,
  CULTIVATION_DETAILS: {
    MAIN: CULTIVATION_DETAILS,
  },
};
